/* Animerch – snel bestellen op productkaarten
   - aantal-stepper per kaart
   - AJAX toevoegen via /cart/add.js (pagina blijft staan)
   - winkelmand-teller bijwerken + bevestigingsdrawer met verzendbalk en aanbeveling */
(() => {
  if (window.AmQuickAdd) return;
  window.AmQuickAdd = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const LANG = document.documentElement.lang || 'nl';
  let currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  let lastTrigger = null;

  const $drawer = () => document.querySelector('[data-am-drawer]');
  const money = (cents) =>
    new Intl.NumberFormat(LANG, { style: 'currency', currency }).format((cents || 0) / 100);
  const imgUrl = (src, width) => {
    if (!src) return '';
    const url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  };
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  /* ---------- API ---------- */
  async function addItems(items, sections) {
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
    return data;
  }
  async function getCart() {
    const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    if (cart.currency) currency = cart.currency;
    return cart;
  }

  /* ---------- Stepper ---------- */
  function sync(wrap) {
    const input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 99;
    let v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = Math.min(max, Math.max(min, v));
    input.value = v;
    wrap.querySelector('[data-am-step="-1"]').disabled = v <= min;
    wrap.querySelector('[data-am-step="1"]').disabled = v >= max;
    const hint = wrap.querySelector('[data-am-hint]');
    if (hint) hint.hidden = !(v >= max && max > 1 && max < 99);
  }

  function setBtn(btn, state) {
    btn.dataset.state = state;
    btn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    const label = btn.querySelector('[data-am-label]');
    label.textContent =
      state === 'loading' ? 'Toevoegen…' : state === 'done' ? 'Toegevoegd' : btn.dataset.label;
    btn.title = label.textContent;
  }

  function showError(wrap, msg) {
    const box = wrap.querySelector('[data-am-error]');
    if (!box) return;
    box.textContent = msg || '';
    box.hidden = !msg;
  }

  /* ---------- Winkelmand-teller ---------- */
  function updateCartIcon(sections, cart) {
    const html = sections && sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (html && bubble) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
    document.querySelectorAll('[data-cart-count]').forEach((n) => (n.textContent = cart.item_count));

    // Empire (Pixel Union): teller staat in .site-header-cart--count via data-header-cart-count
    document.querySelectorAll('[data-header-cart-count]').forEach((n) => {
      n.setAttribute('data-header-cart-count', cart.item_count);
      n.classList.toggle('visible', cart.item_count > 0);
    });

    const icon =
      bubble ||
      document.querySelector('[data-cart-icon]') ||
      document.querySelector('.site-header-cart--button, .site-header-cart');
    if (icon) {
      icon.classList.remove('am-bump');
      void icon.offsetWidth;
      icon.classList.add('am-bump');
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'am-quick-add', cartData: cart });
    }
  }

  /* ---------- Toevoegen vanaf kaart ---------- */
  function useThemeDrawer() {
    const d = $drawer();
    const themeDrawer = document.querySelector('cart-drawer');
    const wantsTheme = !d || d.dataset.mode === 'theme';
    return wantsTheme && themeDrawer && typeof themeDrawer.renderContents === 'function';
  }

  async function addFromForm(form) {
    const wrap = form.closest('[data-am-qa]');
    const btn = form.querySelector('[data-am-add]');
    if (!btn || btn.dataset.state === 'loading') return;

    sync(wrap);
    const id = parseInt(form.querySelector('[name="id"]').value, 10);
    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = parseInt(qtyInput.value, 10) || 1;
    const theme = useThemeDrawer();

    setBtn(btn, 'loading');
    showError(wrap, '');
    try {
      const data = await addItems(
        [{ id, quantity }],
        theme ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble']
      );
      const cart = await getCart();
      updateCartIcon(data.sections, cart);
      setBtn(btn, 'done');
      lastTrigger = btn;
      setTimeout(() => {
        setBtn(btn, 'idle');
        qtyInput.value = 1;
        sync(wrap);
      }, 1800);

      if (theme) {
        document.querySelector('cart-drawer').renderContents(data);
      } else {
        const added = (data.items && data.items[0]) || null;
        openDrawer(added, quantity, cart, wrap.dataset.productId);
      }
    } catch (err) {
      setBtn(btn, 'idle');
      showError(wrap, err.message);
    }
  }

  /* ---------- Drawer ---------- */
  function renderTotals(cart) {
    const d = $drawer();
    if (!d) return;
    d.querySelector('[data-am-count]').textContent = cart.item_count;
    d.querySelector('[data-am-subtotal]').textContent = money(cart.total_price);

    const free = parseInt(d.dataset.freeFrom, 10) || 0;
    const ship = d.querySelector('[data-am-ship]');
    if (!free) { ship.hidden = true; return; }
    const left = Math.max(0, free - cart.total_price);
    ship.hidden = false;
    d.querySelector('[data-am-ship-text]').textContent =
      left > 0 ? `Nog ${money(left)} tot gratis verzending` : 'Je bestelling wordt gratis verzonden';
    d.querySelector('[data-am-ship-bar]').style.width = Math.min(100, (cart.total_price / free) * 100) + '%';
  }

  function renderItem(item, addedQty) {
    const box = $drawer().querySelector('[data-am-item]');
    box.replaceChildren();
    if (!item) return;
    const media = el('div', 'am-drawer__thumb');
    if (item.image) {
      const img = el('img');
      img.src = imgUrl(item.image, 160);
      img.alt = '';
      img.width = 72;
      img.height = 88;
      media.append(img);
    }
    const info = el('div', 'am-drawer__info');
    info.append(
      el('p', 'am-drawer__name', item.product_title),
      el('p', 'am-drawer__meta', `${addedQty} toegevoegd · ${item.quantity} in je winkelmand`)
    );
    const price = el('p', 'am-drawer__price', money(item.final_price * addedQty));
    box.append(media, info, price);
  }

  async function renderRecommendation(productId, cart) {
    const d = $drawer();
    const box = d.querySelector('[data-am-rec]');
    const slot = d.querySelector('[data-am-rec-item]');
    box.hidden = true;
    slot.replaceChildren();
    if (!productId) return;

    const inCart = new Set(cart.items.map((i) => i.product_id));
    for (const intent of ['complementary', 'related']) {
      try {
        const res = await fetch(
          `${ROOT}recommendations/products.json?product_id=${productId}&limit=4&intent=${intent}`
        );
        if (!res.ok) continue;
        const { products = [] } = await res.json();
        const p = products.find((x) => x.available && !inCart.has(x.id));
        if (!p) continue;
        const variant = p.variants.find((v) => v.available) || p.variants[0];

        const row = el('div', 'am-drawer__rec-row');
        const thumb = el('div', 'am-drawer__rec-thumb');
        if (p.featured_image) {
          const img = el('img');
          img.src = imgUrl(p.featured_image, 120);
          img.alt = '';
          img.width = 48;
          img.height = 48;
          thumb.append(img);
        }
        const info = el('div', 'am-drawer__rec-info');
        const link = el('a', 'am-drawer__rec-name', p.title);
        link.href = p.url;
        info.append(link, el('span', 'am-drawer__rec-price', money(variant.price)));
        const add = el('button', 'am-drawer__rec-add');
        add.type = 'button';
        add.dataset.amRecAdd = variant.id;
        add.setAttribute('aria-label', `${p.title} toevoegen`);
        add.innerHTML =
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="2" rx="1"/><rect x="11" y="5" width="2" height="14" rx="1"/></svg>';
        row.append(thumb, info, add);
        slot.append(row);
        box.hidden = false;
        return;
      } catch (e) { /* volgende intent proberen */ }
    }
  }

  function openDrawer(item, addedQty, cart, productId) {
    const d = $drawer();
    if (!d) return;
    renderItem(item, addedQty);
    renderTotals(cart);
    renderRecommendation(productId, cart);
    d.hidden = false;
    document.documentElement.classList.add('am-lock');
    requestAnimationFrame(() => {
      d.classList.add('is-open');
      d.querySelector('.am-drawer__panel').focus();
    });
  }

  function closeDrawer() {
    const d = $drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('am-lock');
    setTimeout(() => (d.hidden = true), 250);
    if (lastTrigger) lastTrigger.focus();
  }

  async function addRecommendation(btn) {
    if (btn.disabled) return;
    btn.disabled = true;
    try {
      const data = await addItems([{ id: parseInt(btn.dataset.amRecAdd, 10), quantity: 1 }], ['cart-icon-bubble']);
      const cart = await getCart();
      updateCartIcon(data.sections, cart);
      renderTotals(cart);
      btn.classList.add('is-done');
      btn.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5 10 17l9-10"/></svg>';
      btn.setAttribute('aria-label', 'Toegevoegd');
    } catch (e) {
      btn.disabled = false;
    }
  }

  /* ---------- Events (gedelegeerd, werkt ook na filteren/infinite scroll) ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-am-step]');
    if (step) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = step.closest('[data-am-qa]');
      const input = wrap.querySelector('input[name="quantity"]');
      input.value = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.amStep, 10);
      sync(wrap);
      return;
    }
    const rec = e.target.closest('[data-am-rec-add]');
    if (rec) { e.preventDefault(); addRecommendation(rec); return; }
    if (e.target.closest('[data-am-close]')) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-am-qa] input[name="quantity"]')) sync(e.target.closest('[data-am-qa]'));
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-am-qa] form');
    if (!form) return;
    e.preventDefault();
    addFromForm(form);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
})();